var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.242,
    height: 16.94,
    viewBox: "0 0 15.242 16.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings_2_",
    "data-name": "settings (2)",
    transform: "translate(-1.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15554",
    "data-name": "Path 15554",
    d: "M10.823,8a2.823,2.823,0,1,0,2.823,2.823A2.823,2.823,0,0,0,10.823,8Zm0,4.235a1.412,1.412,0,1,1,1.412-1.412A1.412,1.412,0,0,1,10.823,12.235Z",
    transform: "translate(-2 -2.353)",
    fill: "#23bee3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15555",
    "data-name": "Path 15555",
    d: "M15.384,9.811,15.07,9.63a6.423,6.423,0,0,0,0-2.322l.313-.181a2.119,2.119,0,1,0-2.117-3.67l-.314.181A6.336,6.336,0,0,0,10.941,2.48V2.117a2.117,2.117,0,0,0-4.235,0V2.48A6.336,6.336,0,0,0,4.7,3.641l-.316-.183a2.119,2.119,0,1,0-2.117,3.67l.313.181a6.423,6.423,0,0,0,0,2.322l-.313.181a2.119,2.119,0,1,0,2.117,3.67l.314-.181A6.336,6.336,0,0,0,6.706,14.46v.362a2.117,2.117,0,0,0,4.235,0V14.46a6.336,6.336,0,0,0,2.01-1.162l.316.182a2.119,2.119,0,1,0,2.117-3.67Zm-1.8-2.665a4.975,4.975,0,0,1,0,2.647.706.706,0,0,0,.328.8l.765.442a.706.706,0,1,1-.706,1.223l-.767-.443a.706.706,0,0,0-.858.116,4.93,4.93,0,0,1-2.289,1.323.706.706,0,0,0-.53.684v.884a.706.706,0,0,1-1.412,0v-.884a.706.706,0,0,0-.53-.684A4.93,4.93,0,0,1,5.3,11.929a.706.706,0,0,0-.858-.116l-.765.443a.706.706,0,1,1-.706-1.223l.765-.442a.706.706,0,0,0,.328-.8,4.975,4.975,0,0,1,0-2.647.706.706,0,0,0-.328-.8L2.97,5.9a.706.706,0,0,1,.706-1.223l.767.443A.706.706,0,0,0,5.3,5.011,4.93,4.93,0,0,1,7.588,3.688.706.706,0,0,0,8.118,3V2.117a.706.706,0,0,1,1.412,0V3a.706.706,0,0,0,.53.684,4.93,4.93,0,0,1,2.289,1.326.706.706,0,0,0,.858.116l.765-.443a.706.706,0,1,1,.706,1.223l-.765.442a.706.706,0,0,0-.327.8Z",
    fill: "#23bee3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings2);
export default __webpack_public_path__ + "static/media/settings (2).9a0bf29f28d4b5f5f66ca606b0d0c12c.svg";
export { ForwardRef as ReactComponent };